import { render, staticRenderFns } from "./ViewOrderDetails.vue?vue&type=template&id=34b9f0e4&"
import script from "./ViewOrderDetails.vue?vue&type=script&lang=js&"
export * from "./ViewOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports